/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\SUZUKI.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:24:39 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function SUZUKI(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M440.43,369.07c-64.5,42.55-132.03,71.33-144.59,76.54l318.47,223.05c.33,.23,.52,.61,.51,1.01h0c0,.42-.21,.8-.55,1.02l-14.22,9.36c-.42,.27-.95,.26-1.36-.01l-116.3-80.05c-44.38-29.98-93.33-23.62-126.57-12.99-31.91,10.18-55.42,25.78-61.23,29.85,2.79,1.95,240.57,168.13,242.17,169.26,5.13-4.82,39.97-36.63,113.19-81.81,77.21-47.56,122.73-64.19,133.26-67.71l-319.06-223.43c-.33-.23-.52-.6-.52-1h0c0-.42,.21-.79,.54-1.02l13.58-9c.41-.27,.93-.27,1.34,0,.43,.28,43.2,28.36,120.1,82.5,72.1,50.72,172.66-10.1,186.48-18.93-2.92-2.02-244.48-170.31-246.01-171.38-6.04,5.15-50.6,42.75-99.25,74.75Z"/>
        </svg>
    );
}

export default SUZUKI;
